import React, { useEffect, useState } from "react";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { getPartsRepairHistoryDetailsList } from "../../services/RepairServices";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import DesmeImage from "../../asset/images/dismantle_icon.svg";

const HistoryRepairAllList = () => {
  const location = useLocation();
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { uuid } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const RolePermission = Utils.getRecordForCurrentPath(location);

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);

  const [historyRepairList, setHistoryRepairList] = useState([]);

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value); // Save search to localStorage
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    }
    setParams(paramsObj);
  };

  const fetchRepairParts = () => {
    if (!uuid) return;
    let data = { ...params, id: uuid };
    getPartsRepairHistoryDetailsList(data)
      .then((response) => {
        setHistoryRepairList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(() => {
    if (uuid) {
      fetchRepairParts();
    }
  }, [params, uuid]);

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                {/* <h1 className="page-title">Part Side</h1> */}
              </div>
              <div className="col-sm-6"></div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new ">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="">
                    <div className="">
                      <div className="card-header">
                        <div
                          className="card-title m-0 float-left"
                          style={{ width: "50%" }}
                        >
                          <input
                            type="text"
                            className="form-control"
                            value={params.search}
                            onChange={(e) => handleParams(e, "search")}
                            placeholder={t("search")}
                          ></input>
                        </div>
                        <div className="card-title m-0 float-right d-flex">
                       
                          <button
                            type="button"
                            className="btn btn-block btn-primary"
                            onClick={() => navigate("/history-repairs-process")}
                            style={{ width: "100px", marginTop: "10px" }}
                          >{t("back")}<i className="bi bi-arrow-left-short"></i>
                          </button>
                        </div>
                      </div>
                      <div className="card-body fuelCardB">
                        <div className="vehicleThBg table-responsive">
                          <table className="table table-bordered rounded-table table table-striped table-hover">
                            <thead>
                              <tr>
                                <th style={{ width: "10%" }}>
                                  {t("created_name")}
                                </th>
                                <th style={{ width: "10%" }}>
                                  {t("created_at")}
                                </th>
                                {/* <th style={{ width: "10%" }}>
                                  {t("from_part_code")}
                                </th>
                                <th style={{ width: "10%" }}>
                                  {t("to_part_code")}
                                </th> */}
                                {/* <th style={{ width: "10%" }}>
                                  {t("nameFromPartPT")}
                                </th>
                                <th style={{ width: "10%" }}>
                                  {t("nameToPartPT")}
                                </th> */}
                                <th style={{ width: "10%" }}>
                                  {t("from_part_name")}
                                </th>
                                <th style={{ width: "10%" }}>
                                  {t("to_part_name")}
                                </th>
                                <th style={{ width: "10%" }}>{t("action")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {" "}
                              {historyRepairList?.map((item, index) => {
                                return (
                                  <>
                                    <tr key={index}>
                                      <td>{item?.created_name}</td>
                                      <td>
                                        {moment(item?.created_at).format(
                                          "DD/MM/YYYY HH:mm",
                                        )}
                                      </td>
                                      {/* <td>{item.from_part_code}</td>
                                      <td>{item.to_part_code}</td> */}
                                      {/* <td>{item.nameFromPartPT}</td>
                                      <td>{item.nameToPartPT}</td> */}
                                      <td>{item.from_part_name}</td>
                                      <td>{item.to_part_name}</td>
                                      <td className="d-flex">
                                        <Dropdown
                                          className="iconDropdown"
                                          onToggle={(isOpen) => {
                                            if (isOpen) {
                                              // This logic runs when the dropdown is opened
                                              const tableResponsive =
                                                document.querySelector(
                                                  ".table-responsive",
                                                );
                                              if (tableResponsive) {
                                                tableResponsive.style.overflowX =
                                                  "inherit !important";
                                                tableResponsive.style.overflowY =
                                                  "inherit !important";
                                              }
                                            }
                                          }}
                                        >
                                          <Dropdown.Toggle
                                            variant="success"
                                            id="dropdown-basic"
                                            className="iconToggle"
                                          >
                                            <i className="bi bi-three-dots-vertical"></i>
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <Dropdown.Item
                                              href="#/action-1"
                                              className="d-flex"
                                              onClick={() => {
                                                navigate(
                                                  `/parts-inventory/AddParts/${item.part_to_id}`,
                                                  {
                                                    state: item,
                                                  },
                                                );
                                              }}
                                            >
                                              <a className="edit-btn" href="#">
                                                <i className="bi bi-pencil"></i>
                                              </a>

                                              <span>{t("edit")}</span>
                                            </Dropdown.Item>

                                            <Dropdown.Item
                                              className="d-flex"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                if (item) {
                                                  navigate(
                                                    `/part/details/inven/${item.part_from_id}`,
                                                    {
                                                      state: item,
                                                    },
                                                  );
                                                }
                                              }}
                                            >
                                              <button
                                                className="edit-btn"
                                                onClick={(e) =>
                                                  e.preventDefault()
                                                }
                                              >
                                                <img
                                                  src={DesmeImage}
                                                  style={{ width: "66%" }}
                                                />
                                              </button>
                                              <span>Part Details</span>
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}{" "}
                            </tbody>{" "}
                            {historyRepairList &&
                              historyRepairList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {" "}
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                          </table>
                        </div>
                      </div>{" "}
                      {/* /.card-body */}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div className="card-footer card-footer-part clearfix">
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HistoryRepairAllList;
